import JSEncrypt from 'jsencrypt';
import axios from 'axios';

// 需要加密的密码字段（后端 CommonReq 约定），有值才加密，空值保持原样
const PASSWORD_FIELDS = ['password', 'oldPassword', 'newPassword', 'tranPwd', 'tranPassword'];

// 公钥进程内缓存
let cachedPublicKey = '';
// 并发取公钥时合并为同一个请求
let pendingPublicKeyRequest = null;

// 清空公钥缓存（密钥轮换 / SECURITY001 时调用）
export function clearPublicKey() {
    cachedPublicKey = '';
}

// 服务端下发的是不带 PEM 头尾的纯 Base64，jsencrypt 需要完整 PEM 结构
function toPem(publicKey) {
    const key = String(publicKey || '');
    if (key.indexOf('-----BEGIN') >= 0) {
        return key;
    }
    const lines = key.replace(/\s+/g, '').match(/.{1,64}/g) || [];
    return '-----BEGIN PUBLIC KEY-----\n' + lines.join('\n') + '\n-----END PUBLIC KEY-----';
}

// 获取 RSA 公钥：默认读缓存，force=true 时强制刷新（body 必须传空对象）
export function getPublicKey(force = false) {
    if (cachedPublicKey && !force) {
        return Promise.resolve(cachedPublicKey);
    }
    if (!pendingPublicKeyRequest) {
        pendingPublicKeyRequest = axios.post('/user/getPublicKey', {}).then(res => {
            const data = (res && res.data && res.data.data) || {};
            if (!data.publicKey) {
                throw new Error('获取RSA公钥失败');
            }
            cachedPublicKey = data.publicKey;
            pendingPublicKeyRequest = null;
            return cachedPublicKey;
        }).catch(error => {
            pendingPublicKeyRequest = null;
            throw error;
        });
    }
    return pendingPublicKeyRequest;
}

// 加密单个密码字段
export function encryptPassword(plain, publicKey) {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(toPem(publicKey));
    const cipher = encryptor.encrypt(plain);
    if (!cipher) {
        throw new Error('密码加密失败');
    }
    return cipher;
}

// 统一加密请求体中的密码字段；加密了任一字段则补 encryptType=RSA
export function encryptRequestBody(body, force = false) {
    // 仅处理普通对象，跳过 FormData、字符串等
    if (!body || Object.prototype.toString.call(body) !== '[object Object]') {
        return Promise.resolve(body);
    }
    const fields = PASSWORD_FIELDS.filter(field => typeof body[field] === 'string' && body[field]);
    if (!fields.length) {
        return Promise.resolve(body);
    }
    return getPublicKey(force).then(publicKey => {
        const result = Object.assign({}, body);
        fields.forEach(field => {
            result[field] = encryptPassword(result[field], publicKey);
        });
        result.encryptType = 'RSA';
        return result;
    });
}
